(function(){
  var hd=document.getElementById('hd');
  if(hd){var onScroll=function(){hd.classList.toggle('scrolled',window.scrollY>30)};onScroll();window.addEventListener('scroll',onScroll,{passive:true});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.18});
  document.querySelectorAll('.card,.reveal').forEach(function(el){io.observe(el)});
})();
// FAQ accordion
document.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var open=btn.getAttribute('aria-expanded')==='true';
    var ans=btn.nextElementSibling;
    btn.setAttribute('aria-expanded',String(!open));
    ans.style.maxHeight=open?null:ans.scrollHeight+'px';
  });
});
